
<div class="alert-stack">
  <div *ngFor="let item of notificationsArray">
    <div id="{{item.id}}" class="alert alert-{{ item.messageType }} {{  item.topPos }} {{  item.textAlign }} animated fadeIn">
      <div class="alert-heading" [class.flex-always]="item.title">
        <span *ngIf="item.title">{{ item.title }}</span>
        <button class="close close-btn" *ngIf="item.isSticky" (click)="closeNotification(item.id)"><i class="icon">cross</i></button>
      </div>
      <i *ngIf="item.icon" class="icon">{{ item.icon }}</i>
      <span class="error-text" [innerHTML]="item.text"></span>
    </div>
  </div>
</div>

